import styled from 'styled-components'

export const DateAndTimeContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: fixed;
  top: 0;
  background: white;
  overflow: hidden;
  z-index: 9999;
  font-family: 'Rubik';

  .btn__primary:disabled {
    background: #7d807e;
    font-family: 'Rubik';
  }

  .btn__primary {
    background: #ff6d38;
    font-family: 'Rubik';
  }

  .journeyLabel {
    color: #ff6d38 !important;
    font-family: 'Rubik';
  }

  .regularTxtStyle {
    font-family: 'Rubik' !important;
  }

  .dtFooterInput .addate {
    margin-left: 2% !important;
  }

  .dtFooterInput {
    width: 49% !important;
  }

  .dtFooter {
    background-color: #ffffff;
    width: 100% !important;
    bottom: 0px !important;
  }

  .selected-item-view {
    background-color: #ff6d38;
  }

  @media only screen and (max-height: 700px) {
    .datePicker-title {
      font-size: 14px;
    }

    .date-picker-wrapper {
      height: 365px;
    }

    ul li {
      font-size: 14px;
    }
  }
`;

export const DateAndTimeHeader = styled.div`
  color: #4a4a4a;
  font-family: 'Rubik';
  font-weight: 400;
  font-size: 14px;
`;

export const DateAndTimeWrapper = styled.div`
  display: flex;
  position: relative;
  padding: 16px 20px;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 3px -1px rgba(0, 0, 0, 0.1);

  img.BackIc {
    width: 24px;
    height: 24px;
    position: absolute;
    left: 24px;
  }

  span {
    font-family: 'Rubik';
    font-weight: 700;
    font-size: 18px;
  }

  @media only screen and (max-height: 700px) {
    span {
    font-size: 16px;
  }
  
  }

`;

export const ErrorMessageBox = styled.div`
  width: 300px;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  z-index: 2;
  position: absolute;
  bottom: 20%;
  border-radius: 6px;
  padding: 10px 16px;
  font-size: 12px;
  text-align: center;
  font-family: 'Rubik';
  font-weight: 400;
  background-color: #000;
  color: #fff;
  margin-top: 10px;
`;

